export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOGFIN02.55224f77.mp3";